<script>
import PrefectureList from '../../../../../mixins/PrefectureList'
import ZipCodeSearch from '../../../../../components/ZipCodeSearch'
import SearchZipModal from "../../../../components/SearchZipModal.vue";

export default {
  name: "NoneReportTraderLocationForm",
  components: {ZipCodeSearch, SearchZipModal},
  mixins: [ PrefectureList ],
  props: {
    location: {
      type: Object,
      default: () => {},
    },
    trader: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      enableSearchZipModal: false,
    }
  },
  watch: {

  },
  methods: {
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    searchZipCallback (content) {
      this.location.prefecture_code = `${content.pref_code}`
      this.location.address_1 = `${content.locality}`
      this.location.address_2 = `${content.street}`
    },
    closeModalCallback () {
      this.enableSearchZipModal = false;
    },
    /**
     * 郵便番号検索反映ボタン コールバック
     * @param address { Object }
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { number } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    searchZipReflectCallback (address) {
      this.location.zip_code = address.zip_code
      this.location.prefecture_code = `${address.prefecture_code}`
      this.location.address_1 = address.city
      this.location.address_2 = address.town
    },
    searchZipReflectZipCallback (zipCode) {
      this.location.zip_code = zipCode;
    },
  }
}
</script>

<template>
  <div v-if="location" class="mt-1">
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <validation-provider
          v-slot="{ errors }"
          class="requiredMark"
          name="事業場コード"
          rules="required|alpha_num_only|max:10"
          vid="trader_location_code"
        >
          <v-text-field
            v-model="location.code"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="事業場コード"
            outlined
            persistent-placeholder
            placeholder="例）001"
          >
            <template v-slot:label>
              <span>事業場コード</span>
              <span class="ml-1">
                ({{ location.code?.length || 0 }} / 10)
              </span>
            </template>
            <template v-slot:counter></template>
          </v-text-field>
        </validation-provider>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        最近使用したコード:&nbsp;<strong>{{ location.recent_registered_codes }}</strong>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
          class="requiredMark"
          name="事業場名"
          rules="required|max:60"
          vid="trader_location_name"
        >
          <v-text-field
            v-model="location.name"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="事業場名"
            outlined
            persistent-placeholder
            placeholder="例）△△△△　株式会社"
          >
            <template v-slot:label>
              <span>事業場名</span>
              <span class="ml-1">
                ({{ location.name?.length || 0 }} / 60)
              </span>
            </template>
            <template v-slot:counter></template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5">
        <validation-provider
          v-slot="{ errors }"
          :rules="{zip_code: true, required: true, max:8 }"
          class="requiredMark"
          name="郵便番号"
          vid="trader_location_zip_code"
        >
          <v-text-field
            v-model="location.zip_code"
            :error-messages="errors"
            dense
            label="郵便番号"
            hide-details="auto"
            hint="ハイフンを含めて入力してください"
            outlined
            persistent-hint
            persistent-placeholder
            placeholder="例）111-1111"
            required
          >
            <template v-slot:label>
              <span>郵便番号</span>
              <span class="ml-1">
                ({{ location.zip_code?.length || 0 }} / 8)
              </span>
            </template>
            <template v-slot:counter></template>
            <template v-slot:append-outer>
              <zip-code-search
                :zip-code="location.zip_code"
                @zipAddress="searchZipCallback"
              />
              &nbsp;
              <v-btn
                outlined
                small
                @click="searchZipButtonClickEvent"
              >
                住所→郵便番号
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /郵便番号 -->

    <!-- 都道府県／市区町村 -->
    <v-row>
      <v-col cols="12" md="3">
        <validation-provider
          v-slot="{ errors }"
          class="requiredMark"
          name="都道府県"
          rules="required"
          vid="trader_location_prefecture_code"
        >
          <v-autocomplete
            v-model="location.prefecture_code"
            :error-messages="errors"
            :items="prefList"
            dense
            hide-details="auto"
            item-text="text"
            item-value="value"
            label="都道府県"
            outlined
            persistent-placeholder
            placeholder="例）東京都"
          />
        </validation-provider>
      </v-col>
      <v-col cols="12" md="6">
        <validation-provider
          v-slot="{ errors }"
          class="requiredMark"
          name="市区町村"
          rules="required|full_width|max:20"
          vid="trader_location_address_1"
        >
          <v-text-field
            v-model="location.address_1"
            :error-messages="errors"
            dense
            label="市区町村"
            hide-details="auto"
            outlined
            persistent-placeholder
            placeholder="例）中央区"
          >
            <template v-slot:label>
              <span>市区町村</span>
              <span class="ml-1">
                ({{ location.address_1?.length || 0 }} / 20)
              </span>
            </template>
            <template v-slot:counter></template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /都道府県／市区町村 -->

    <!-- 町域 -->
    <v-row>
      <v-col cols="12" md="9">
        <validation-provider
          v-slot="{ errors }"
          name="町域"
          rules="full_width|max:40"
          vid="trader_location_address_2"
        >
          <v-text-field
            v-model="location.address_2"
            :error-messages="errors"
            dense
            label="町域"
            hide-details="auto"
            outlined
            persistent-placeholder
            placeholder="例）日本橋兜町"
          >
            <template v-slot:label>
              <span>町域</span>
              <span class="ml-1">
                ({{ location.address_2?.length || 0 }} / 40)
              </span>
            </template>
            <template v-slot:counter></template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /町域 -->

    <!-- 詳細住所 -->
    <v-row>
      <v-col md="9">
        <validation-provider
          v-slot="{ errors }"
          name="詳細住所"
          rules="max:50"
          vid="trader_location_address_3"
        >
          <v-text-field
            v-model="location.address_3"
            :error-messages="errors"
            dense
            label="詳細住所"
            hide-details="auto"
            outlined
            persistent-placeholder
            placeholder="例）１−２−３　○○ビル○階"
          >
            <template v-slot:label>
              <span>詳細住所</span>
              <span class="ml-1">
                ({{ location.address_3?.length || 0 }} / 50)
              </span>
            </template>
            <template v-slot:counter></template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /詳細住所 -->

    <!-- 電話番号 -->
    <v-row>
      <v-col cols="12" md="6">
        <validation-provider
          v-slot="{ errors }"
          :rules="{ numeric_hyphen_only: true,min: 2, max: 15 }"
          name="電話番号"
          vid="trader_location_phone_number"
        >
          <v-text-field
            v-model="location.phone_number"
            :error-messages="errors"
            dense
            label="電話番号"
            hint="電話番号を「-」ハイフン「( )」込みで入力します"
            persistent-hint
            hide-details="auto"
            outlined
            persistent-placeholder
            placeholder="例）000-0000-0000"
          >
            <template v-slot:label>
              <span>電話番号</span>
              <span class="ml-1">
                ({{ location.phone_number?.length || 0 }} / 15)
              </span>
            </template>
            <template v-slot:counter></template>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <!-- /電話番号 -->

    <!-- 事業場区分 -->
    <v-row>
      <v-col cols="12" md="8">
        <v-radio-group
          v-model="location.location_type"
          label="事業場区分"
          row
          dense
          hide-details="auto"
          class="pa-0 ma-0"
        >
        <v-radio
          v-if="trader.subscriber_type === 'transport_type'"
          label="積替・保管"
          value="transshipment"
        />
        <v-radio
          v-if="trader.subscriber_type === 'disposer_type'"
          label="中間処理のみ"
          value="only_middle"
        />
        <v-radio
          v-if="trader.subscriber_type === 'disposer_type'"
          label="最終処分のみ"
          value="only_last"
        />
        <v-radio
          v-if="trader.subscriber_type === 'disposer_type'"
          label="中間処理＋最終処分"
          value="middle_and_last"
        />
        </v-radio-group>
      </v-col>
    </v-row>
    <!-- /事業場区分 -->
    <search-zip-modal
      :enable="enableSearchZipModal"
      :initial-prefecture-code="location.prefecture_code"
      :initial-city-name="location.address_1"
      :initial-town-name="location.address_2"
      @reflectFullCallback="searchZipReflectCallback"
      @reflectZipCallback="searchZipReflectZipCallback"
      @closeCallback="closeModalCallback"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
